import { ImageResponseData } from '../background/types';

/**
 * Requests an image through the background script to avoid CSP issues
 * @param url The image URL to fetch
 * @param name Optional name for the image
 * @returns Promise that resolves to image data or null if failed
 */
export async function requestImageThroughBackground(
  url: string,
  name?: string,
): Promise<ImageResponseData | null> {
  try {
    const response = (await chrome.runtime.sendMessage({
      type: 'IMAGE_REQUEST',
      config: { url, name },
    })) as { success: boolean; data?: ImageResponseData; error?: string };

    if (response.success && response.data) {
      return response.data;
    } else {
      console.error('Image request failed:', response.error);
      return null;
    }
  } catch (error) {
    console.error('Error requesting image through background:', error);
    return null;
  }
}
